<template lang="pug">
  div.container-fluid.animated.fadeIn
    nav(aria-label="breadcrumb")
      b-breadcrumb
        b-breadcrumb-item
          router-link(to="/system")
            i.fa.fa-desktop
            span.ml-1 {{ $t("ui.system") }}
        b-breadcrumb-item
          router-link(to="/system/page")
            i.far.fa-file
            span.ml-1 {{ $tc("ui.pages", 2) }}
    div.row.mb-5
      div.col-md-12
        div.card
          div.card-header
            div.row
              div.col-md-12.mb-1
                div.form-row
                  div.col-md-6.mb-1
                    b-input-group(size="sm")
                      b-input-group-text(slot="prepend")
                        i.fa.fa-search
                      DebounceInput(required autofocus type="text" v-model="pageSearch" :placeholder="$t('message.search_by_id_name')")
                  div.col-md-1.mb-1
                    b-form-radio-group(
                      buttons
                      v-model="filterBy"
                      size="sm"
                      button-variant="outline-info"
                    )
                      b-form-radio(value="id") {{ $t("ui.id") }}
                      b-form-radio(value="name") {{ $t("ui.name") }}
            div.row
              div.col-md-12
                b-button(v-b-modal.addPage type="button" variant="primary" size="sm").mr-1
                  i.fa.fa-plus
                  span {{ $t("ui.combine.add_page") }}
          div.card-body.p-1.clusterize
            .clusterize-scroll
              table.tablex(style="width: auto;" v-columns-resizable)
                thead
                  tr
                    th.sticky-position
                      span {{ $t('ui.id') }}
                    th.text-center.sticky-position(width=120)
                      span {{ $t("ui.action") }}
                    th.sticky-position
                      span {{ $t("ui.name") }}
                    th.text-right.sticky-position(width=200)
                      span {{ $t("ui.created_on") }}
                tbody.clusterize-content
                  tr(v-for="(item, index) in filteredPageList")
                    td
                      span {{ item.page_id }}
                    td.actions
                      span
                        a.fa.fa-edit.text-primary(href="#" @click="onEdit(item)" :title="$t('ui.edit')")
                      span
                        a.fa.fa-trash.text-danger(href="#" @click="onDelete(item)" :title="$t('ui.delete')")
                      span
                        a.fa.fa-id-card.text-info(href="#" @click="onAssign(item)" :title="$tc('ui.roles', 2)" v-if="roleVisible")
                      span
                        a.fa.fa-cube.text-info(href="#" @click="onAssignPageFunction(item)" :title="$tc('ui.functions', 2)" v-if="functionVisible")
                    td
                      span {{ item.page_name }}
                    td.text-right
                      span {{ $moment(item.created_on).format("YYYY-MM-DD, HH:mm:ss") }}
      addpage(@clicked="addPage" @failed="handleFailed")
      editpage(ref="editpage" :pageId="editSelectedId" :pageName="editSelectedName" @clicked="editPage" @failed="handleFailed")
      deletepage(ref="deletepage" :pageId="deleteSelectedId" :pageName="deleteSelectedName" @clicked="deletePage" @failed="handleFailed")
      assignpagerole(ref="assignpagerole" :pageId="editSelectedId" :pageName="editSelectedName" @clicked="editPageRole" @failed="handleFailed")
      assignpagefunction(ref="assignpagefunction" :pageId="editSelectedId" :pageName="editSelectedName" @clicked="editPageFunction" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import addpage from "@/components/page/addPage.vue";
import editpage from "@/components/page/editPage.vue";
import deletepage from "@/components/page/deletePage.vue";
import assignpagerole from "@/components/page/assignPageRole.vue";
import assignpagefunction from "@/components/page/assignPageFunction.vue";
import DebounceInput from "@/library/DebounceInput";
export default {
  components: {
    addpage,
    editpage,
    deletepage,
    assignpagerole,
    assignpagefunction,
    DebounceInput
  },
  data() {
    return {
      filterBy: "id",
      pageList: [],
      pageSearch: "",
      feedback: {
        success: false,
        status: errorTags.request.failed
      },
      editSelectedId: "",
      editSelectedName: "",
      deleteSelectedId: "",
      deleteSelectedName: ""
    };
  },
  computed: {
    accessRoles() {
      return this.$store.getters.accessRoles;
    },
    filteredPageList() {
      return this.pageList.filter(pageInfo => {
        if (this.filterBy == "name") {
          return pageInfo.page_name.toLowerCase().indexOf(this.pageSearch.toLowerCase()) > -1;
        } else {
          return pageInfo.page_id.indexOf(this.pageSearch.toLowerCase()) > -1;
        }
      });
    }
  },
  mounted: function() {
    let url = config.pageListUrl();

    var json = {
      action_by: this.$store.getters.username,
      session_token: this.$store.getters.sessionToken,
      page_id: config.accessRoles.page
    };

    this.$http.post(url, json).then(
      function(response) {
        // Success
        try {
          if (response) {
            this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

            this.feedback.status = response.data.statusdesc;
            if (this.feedback.success == true) {
              this.pageList = response.data.tbl_page_list;
            } else {
              if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
            }
          }
        } catch (error) {
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      },
      function(response) {
        // Error
        this.feedback.success = false;
        this.feedback.status = errorTags.request.failed;
        this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
      }
    );
  },
  methods: {
    roleVisible() {
      for (var i = 0; i < this.accessRoles.length; i++) {
        if (this.accessRoles[i].page_id == "role") {
          return true;
        }
      }
      return false;
    },
    functionVisible() {
      for (var i = 0; i < this.accessRoles.length; i++) {
        if (this.accessRoles[i].page_id == "function") {
          return true;
        }
      }
      return false;
    },
    onEdit(e) {
      this.editSelectedId = e.page_id;
      this.editSelectedName = e.page_name;
      this.$refs.editpage.$refs.editPage.show();
    },
    onDelete(e) {
      this.deleteSelectedId = e.page_id;
      this.deleteSelectedName = e.page_name;
      this.$refs.deletepage.$refs.deletePage.show();
    },
    onAssign(e) {
      this.editSelectedId = e.page_id;
      this.editSelectedName = e.page_name;
      this.$refs.assignpagerole.$refs.assignPageRole.show();
    },
    onAssignPageFunction(e) {
      this.editSelectedId = e.page_id;
      this.editSelectedName = e.page_name;
      this.$refs.assignpagefunction.$refs.assignPageFunction.show();
    },
    addPage: function(pageId, pageName) {
      let newPage = {
        page_id: pageId,
        page_name: pageName.toUpperCase(),
        created_on: new Date()
      };

      this.pageSearch = "";
      this.pageList.unshift(newPage);
      this.$helpers.showDialog(this.$t("ui.combine.add_page"), this.$t("message.success"), "success");
    },
    editPage: function(pageId, pageName) {
      this.pageList.filter(function(pageInfo) {
        if (pageInfo.page_id == pageId) {
          pageInfo.page_name = pageName.toUpperCase();
        }
      });
      this.$helpers.showDialog(this.$t("ui.combine.edit_page"), this.$t("message.success"), "success");
    },
    deletePage: function(pageId) {
      let i = this.pageList.map(pageInfo => pageInfo.page_id).indexOf(pageId);
      this.pageList.splice(i, 1);
      this.$helpers.showDialog(this.$t("ui.combine.delete_page"), this.$t("message.success"), "success");
    },
    editPageRole: function() {
      this.$helpers.showDialog(this.$t("ui.combine.assign_roles"), this.$t("message.success"), "success");
    },
    editPageFunction: function() {
      this.$helpers.showDialog(this.$t("ui.combine.assign_functions"), this.$t("message.success"), "success");
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
